import React from 'react';
import './AudioPlaybackInfo.scss';

interface AudioPlaybackInfoProps {
    currentIndex: number;
    currentAudioName: string;
    totalCount: number;
    isPlaying: boolean;
}

export const AudioPlaybackInfo: React.FC<AudioPlaybackInfoProps> = ({ 
    currentIndex, 
    currentAudioName,
    totalCount, 
    isPlaying 
}) => {
    const isCompleted = currentIndex >= totalCount && totalCount > 0;
    
    return (
        <div className="AudioPlaybackInfo">
            <div className="AudioStatus">
                {isPlaying && !isCompleted ? (
                    <>
                        <span className="PlayingIcon">{"🔊"}</span>
                        <span>{`Playing ${currentAudioName}`}</span>
                    </>
                ) : isCompleted ? (
                    <>
                        <span className="CompletedIcon">{"✓"}</span>
                        <span>{"All audio tracks completed"}</span>
                    </>
                ) : (
                    <span>{"No audio tracks available"}</span>
                )}
            </div>
        </div>
    );
};